import { useState } from 'react';

export const useTrackLoadedState = (): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  return useState(false);
};
